export default __webpack_public_path__ + "static/media/logo.60ab2bb2.svg";